import { render, staticRenderFns } from "./CommissionsByEntite.vue?vue&type=template&id=37fcc601&"
import script from "./CommissionsByEntite.vue?vue&type=script&lang=js&"
export * from "./CommissionsByEntite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports